var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-group colorpicker-component colorpicker-element" },
    [
      _c("span", { staticClass: "input-group-append" }, [
        _c(
          "span",
          {
            ref: "colorPickerTarget",
            staticClass: "input-group-text p-0 colorpicker-input-addon",
            attrs: { tabindex: "0" },
          },
          [_c("i", { style: "background-color: " + _vm.localColor + ";" })]
        ),
      ]),
      _vm._v(" "),
      _c("material-input", {
        staticClass: "color-picker-input p-0",
        attrs: {
          label: "Colorpicker",
          "hidden-label": true,
          "no-label": "",
          "class-name": "text-uppercase",
        },
        on: { input: _vm.handleChangeColorFromInput, change: _vm.handleChange },
        model: {
          value: _vm.localColor,
          callback: function ($$v) {
            _vm.localColor = $$v
          },
          expression: "localColor",
        },
      }),
      _vm._v(" "),
      _c(
        "b-popover",
        {
          ref: "colorPickerPopover",
          attrs: {
            target: _vm.getPopoverTarget,
            triggers: "click blur",
            placement: _vm.placement,
            "custom-class": "color-picker-popover theme-colorpicker",
            boundary: "viewport",
          },
        },
        [
          _c("chrome-picker", {
            on: { change: _vm.handleChange },
            model: {
              value: _vm.colors,
              callback: function ($$v) {
                _vm.colors = $$v
              },
              expression: "colors",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }